module.exports = __webpack_public_path__ + "assets/img/init_pos_curtain2.a35344ee.png";